module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/Op6lZhL9M4I2wE8osaCw4-077b6f9e383e38fb06d2b42a7aca31fa.jpg";